import { useTranslation } from 'react-i18next';

import {
    Body2,
    FilledCard,
    RichText,
    Stack,
    Subtitle1,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

import { useMedicationDisclaimers } from '../../../../hooks/use-medication-disclosures';

import type { PricingComponentProps } from './pricing-types';

export const GovernmentPricing = ({
    medication,
    price,
    priceType,
}: PricingComponentProps) => {
    const { t } = useTranslation('lilly');

    const richDisclaimers = useMedicationDisclaimers({
        headlinePriceType: priceType,
        medication,
        slot: 'price-card',
    });
    const isBridgePrice = priceType === 'MedicareBridge';
    const showRichDisclaimer = !!richDisclaimers.length;

    return (
        <>
            <FilledCard
                withBorder
                color="primary"
                data-testid="pharmacy-pricing-card"
            >
                <Stack>
                    {isBridgePrice || price === null ? (
                        <Subtitle2>
                            {t('fill.fallback.pricing.finalPriceAtPharmacy')}
                        </Subtitle2>
                    ) : (
                        <>
                            <Subtitle1>
                                {t('fill.fallback.pricing.listPrice', {
                                    price,
                                })}
                            </Subtitle1>
                            <Body2>
                                {t(
                                    'fill.fallback.pricing.finalPriceAtPharmacy'
                                )}
                            </Body2>
                        </>
                    )}
                </Stack>
            </FilledCard>
            {showRichDisclaimer || price !== null ? (
                <Stack data-testid="pharmacy-pricing-terms-and-conditions">
                    {!showRichDisclaimer && price !== null && (
                        <Body2>
                            {t('fill.pricing.feesMayApply', {
                                termsDisclaimer: '',
                            })}
                        </Body2>
                    )}
                    {showRichDisclaimer
                        ? richDisclaimers.map((richDisclaimer) => {
                              const richContent = richDisclaimer.content;

                              return richContent.map(({ key, ...richLine }) => (
                                  <RichText key={key} {...richLine} />
                              ));
                          })
                        : null}
                </Stack>
            ) : null}
        </>
    );
};
